export default __webpack_public_path__ + "static/media/BeeCrying.26fea600.png";